import React, { useState, useContext, createContext } from 'react'
import { USER_RELATIONS } from 'web/src/app/root/constants'

const initialState = {
    name: '',
    lastName: ''
}

const CreateUserContext = createContext(initialState)

export const useCreateUser = () => useContext(CreateUserContext)

export const getNonExistentUserDataForValidation = (state, userRelation) => {
    const dataForValidation = {
        name: state.name,
        lastName: state.lastName,
        password: state.password,
        email: state.email
    }
    if (userRelation === USER_RELATIONS.external) {
        dataForValidation.customer_name = state.customer_name
    }
    return dataForValidation
}

export const CreateUserProvider = ({ children, isFromLocationAssignment }) => {
    const [userState, setUserState] = useState(initialState)
    const [userRelation, setRelation] = useState('')
    const [userRelationFromEmail, setUserRelationFromEmail] = useState('')

    const onUserUpdate = v => {
        setUserState(oldV => ({
            ...oldV,
            ...v
        }))
    }

    const resetUserState = () => {
        setUserState(initialState)
        setRelation('')
        setUserRelationFromEmail('')
    }

    return (
        <CreateUserContext.Provider
            value={{
                userState,
                resetUserState,
                onUserUpdate,
                setRelation,
                userRelation,
                setUserRelationFromEmail,
                userRelationFromEmail,
                isFromLocationAssignment
            }}>
            {children}
        </CreateUserContext.Provider>
    )
}
